/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { Amount } from './Amount';
// @ts-ignore
import {
// @ts-ignore
    AmountFromJSON,
// @ts-ignore
    AmountFromJSONTyped,
// @ts-ignore
    AmountToJSON,
} from './Amount';
// @ts-ignore
import type { BillingDetails } from './BillingDetails';
// @ts-ignore
import {
// @ts-ignore
    BillingDetailsFromJSON,
// @ts-ignore
    BillingDetailsFromJSONTyped,
// @ts-ignore
    BillingDetailsToJSON,
} from './BillingDetails';

/**
 * 
 * @export
 * @interface UpdateInvoiceRequest
 */
export interface UpdateInvoiceRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateInvoiceRequest
     */
    description: string;
    /**
     * 
     * @type {Amount}
     * @memberof UpdateInvoiceRequest
     */
    subtotalAmount: Amount;
    /**
     * 
     * @type {Amount}
     * @memberof UpdateInvoiceRequest
     */
    taxAmount: Amount;
    /**
     * 
     * @type {Amount}
     * @memberof UpdateInvoiceRequest
     */
    totalAmount: Amount;
    /**
     * 
     * @type {BillingDetails}
     * @memberof UpdateInvoiceRequest
     */
    billingDetails?: BillingDetails;
}

/**
 * Check if a given object implements the UpdateInvoiceRequest interface.
 */
// @ts-ignore
export function instanceOfUpdateInvoiceRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "description" in value;
    isInstance = isInstance && "subtotalAmount" in value;
    isInstance = isInstance && "taxAmount" in value;
    isInstance = isInstance && "totalAmount" in value;

    return isInstance;
}

// @ts-ignore
export function UpdateInvoiceRequestFromJSON(json: any): UpdateInvoiceRequest {
    return UpdateInvoiceRequestFromJSONTyped(json, false);
}

// @ts-ignore
export function UpdateInvoiceRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateInvoiceRequest {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'description': json['description'],
        'subtotalAmount': AmountFromJSON(json['subtotal_amount']),
        'taxAmount': AmountFromJSON(json['tax_amount']),
        'totalAmount': AmountFromJSON(json['total_amount']),
        'billingDetails': !exists(json, 'billing_details') ? undefined : BillingDetailsFromJSON(json['billing_details']),
    };
}

// @ts-ignore
export function UpdateInvoiceRequestToJSON(value?: UpdateInvoiceRequest | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'description': value.description,
        'subtotal_amount': AmountToJSON(value.subtotalAmount),
        'tax_amount': AmountToJSON(value.taxAmount),
        'total_amount': AmountToJSON(value.totalAmount),
        'billing_details': BillingDetailsToJSON(value.billingDetails),
    };
}

